module.exports = __webpack_public_path__ + "static/img/alexander_pictgrid8_400x387.1c25e01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alexander_pictgrid8_400x387.jpg
// module id = Jz1E
// module chunks = 0